export function currentAdminEnv() {
  return process.env.REACT_APP_ENV || 'development';
}

/** Human env name for operator copy. Never hardcode "staging" on production. */
export function adminEnvLabel() {
  const env = currentAdminEnv();
  if (env === 'production' || env === 'staging') return env;
  return 'this environment';
}
